"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roZones = void 0;
var roZones = exports.roZones = [{
  id: 'BUCAREST',
  name: 'Bucarest',
  country: 'RO',
  cornerNW: {
    latitude: 44.5572,
    longitude: 25.9726
  },
  cornerSE: {
    latitude: 44.3341,
    longitude: 26.2279
  },
  subZones: [{
    name: 'București Centre historique',
    zipcodes: {
      10000: {
        label: '10000'
      }
    }
  }, {
    name: 'București Militari',
    zipcodes: {
      30167: {
        label: '30167'
      }
    }
  }, {
    name: 'București Secteur 4',
    zipcodes: {
      41914: {
        label: '41914'
      }
    }
  }, {
    name: 'București Secteur 6',
    zipcodes: {
      60000: {
        label: '60000'
      }
    }
  }]
}];